import { AxiosResponse } from 'axios';

import { instance as axios } from 'api/axios';
import { TvResponse } from './interfaces';

export class TvRender {
  static prefix = '/TvRender';

  public static async getTvRender(branchId: number) {
    try {
      const response: AxiosResponse<TvResponse> = await axios.get(TvRender.prefix, { params: { branchId } });
      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }
}
